import { Mfa1 } from "../../../../src/components/images/support/users/Mfa1.generated";
import { Mfa2 } from "../../../../src/components/images/support/users/Mfa2.generated";
import { Mfa3 } from "../../../../src/components/images/support/users/Mfa3.generated";
import * as React from 'react';
export default {
  Mfa1,
  Mfa2,
  Mfa3,
  React
};